import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Tooltip from '@mui/material/Tooltip';
import WavesIcon from '@mui/icons-material/Waves';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import SpeedOutlined from '@mui/icons-material/SpeedOutlined';
import SecurityUpdateGoodIcon from '@mui/icons-material/SecurityUpdateGood';
import HistoryToggleOffOutlined from '@mui/icons-material/HistoryToggleOffOutlined';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Routes, Route, Outlet, Link, useNavigate } from "react-router-dom";
import classes from './listItems.module.css';

type MainListItemsProps = { open?: boolean };

function MainListItems({ open }: MainListItemsProps) {

  let navigate = useNavigate();
  const routeChange = (path: string) => {
    navigate(path);
  }
  return (
    <div className={classes.listEl}>
      <ListItemButton onClick={() => routeChange('dashboard')}>
        <ListItemIcon sx={{ color: 'primary.contrastText', minWidth: 36 }}>
          <Tooltip title="Observatorio" placement="right">
            <WavesIcon />
          </Tooltip>
        </ListItemIcon>
        <ListItemText
          primary="Observatorio"
          primaryTypographyProps={{ color: 'primary.contrastText' }}
          sx={{ display: open ? 'block' : 'none' }}
        />
      </ListItemButton>
      <ListItemButton onClick={() => routeChange('dashboard-legacy')}>
        <ListItemIcon sx={{ color: 'primary.contrastText', minWidth: 36 }}>
          <Tooltip title="Observatorio clásico" placement="right">
            <DashboardCustomizeOutlinedIcon />
          </Tooltip>
        </ListItemIcon>
        <ListItemText
          primary="Observatorio clásico"
          primaryTypographyProps={{ color: 'primary.contrastText' }}
          sx={{ display: open ? 'block' : 'none' }}
        />
      </ListItemButton>
      <ListItemButton onClick={() => routeChange('environmental-feed')}>
        <ListItemIcon sx={{ color: 'primary.contrastText', minWidth: 36 }}>
          <Tooltip title="Feed ambiental" placement="right">
            <DynamicFeedIcon />
          </Tooltip>
        </ListItemIcon>
        <ListItemText
          primary="Feed ambiental"
          primaryTypographyProps={{ color: 'primary.contrastText' }}
          sx={{ display: open ? 'block' : 'none' }}
        />
      </ListItemButton>
      {/* <ListItemButton onClick={() => routeChange('users')}>
        <ListItemIcon>
          <PeopleIcon />
        </ListItemIcon>
        <ListItemText primary="Usuarios" />
      </ListItemButton> */}
      <ListItemButton onClick={() => routeChange('devices')}>
        <ListItemIcon sx={{ color: 'primary.contrastText', minWidth: 36 }}>
          <Tooltip title="Monitoreo" placement="right">
            <SpeedOutlined />
          </Tooltip>
        </ListItemIcon>
        <ListItemText
          primary="Monitoreo"
          primaryTypographyProps={{ color: 'primary.contrastText' }}
          sx={{ display: open ? 'block' : 'none' }}
        />
      </ListItemButton>
      <ListItemButton onClick={() => routeChange('history')}>
        <ListItemIcon sx={{ color: 'primary.contrastText', minWidth: 36 }}>
          <Tooltip title="Análisis Histórico" placement="right">
            <HistoryToggleOffOutlined />
          </Tooltip>
        </ListItemIcon>
        <ListItemText
          primary="Análisis Histórico"
          primaryTypographyProps={{ color: 'primary.contrastText' }}
          sx={{ display: open ? 'block' : 'none' }}
        />
      </ListItemButton>
      <ListItemButton onClick={() => routeChange('analytics')}>
        <ListItemIcon sx={{ color: 'primary.contrastText', minWidth: 36 }}>
          <Tooltip title="Analítica" placement="right">
            <BarChartIcon />
          </Tooltip>
        </ListItemIcon>
        <ListItemText
          primary="Analítica"
          primaryTypographyProps={{ color: 'primary.contrastText' }}
          sx={{ display: open ? 'block' : 'none' }}
        />
      </ListItemButton>
    </div>
  )
}

export default MainListItems;
